const ApiMapper = {
  AUTH: {
    LOGIN: '/login/check',
    CHECK: '/authenticate',
    LOGOUT: '/revoke',
  },
  CROP: {
    GEO: {
      CTPV: '/common/region/ctpv/features', // 시도
      SSG: '/common/region/sgg/features', // 시군구
      EMD: '/common/region/emd/features', // 읍면동
      AI_LIST: '/tree/list/features', // ai 탐지 작물 리스트 - (AI분석결과)
    },
    AI_RESULT: {
      // 탐지 대상 영상(드론, 위성영상, 항공영상) 정보 - (촬영시기, 분석영상)
      // ai feature statistics -- graph, grid..
      STAT: '/tree/statistics',
      // ai list - 상세목록
      LIST: '/tree/list',
      TOTAL: '/tree/total/count',
      DETAIL: '/crops/map/ai/detail',

      // ai list - 상세목록 엑셀다운로드
      LIST_DOWNLOAD: '/tree/excel/download',
      TRANSITION: 'crops/map/ai/transition',
    },
    CULTURE: {
      YEAR_LIST: '/crops/register/form/years', // 신고 연도 리스트
      STAT: '/crops/map/reg/statistics', // 재배 신고 통계
      LIST: '/crops/map/reg/list', // 재배 면적 신고 list - 상세목록
      REPORT_LIST: '/crops/map/reg/detail/list', // 재배 신고 상세 - 신고내역 ( 신고자 정보 아래 내용 )
      TOTAL: '/crops/map/reg/total/count', // 재배 면적 신고 합계
      LIST_DOWNLOAD: '/crops/map/reg/list/excel', // 재배면적신고 엑셀다운로드
      STAT_DOWNLOAD: '/crops/map/reg/crops/area/excel', // 재배면적조사결과집계표
      TRANSITION: 'crops/map/reg/transition',
      IMG_LIST: '/crops/map/reg/detail/image/list', //재배신고 관련 영상 리스트
    },
  },
  COMMON: {
    RESOURCE: '/crops/map/ai/resource', // det_id --> 이미지명,촬영일
    FIND_EMD: '/common/region/find/emd',
    IMAGE_LIST: '/common/image/list',
    SEARCH_ADDR: '/common/region/cadastral/list', //리 이하 주소 검색 리스트

    BOOTSTRAP: {
      CODE_LIST: '/common/code-list', // 임산물 리스트
      CTPV_LIST: '/common/region/ctpv-list', // 시도 리스트
      SGG_LIST: 'common/region/sgg-list', // 시군구 리스트
      EMD_LIST: '/common/region/emd-list', // 읍면동 리스트
      LI_LIST: '/common/region/li-list', // 리 리스트
    },
    CODE: [
      'LBL_TP_CD', //  라벨유형코드
      'ATRB_TP_CD', //속성유형코드
      'JOB_STAE_CD', // 작업상태코드
      'JOB_FDER_CD', //작업폴더코드:
      'DAT_ST_STAE_CD', // 데이터셋상태코드:
      'AI_MDL_CD', //  AIMODEL코드:
      'IMG_KIND_CD', //  이미지종류코드:
      'DOMAIN_KIND_CD', //도메인종류코드:
      'CROPS_CLS_CD', // 작물분류코드:
      'JIMOK_CD', //  지목코드:
      'FORST_KIND_CD', //산림종류코드:
      'FORST_STAT_CD', // 산림상태코드:
      'FORST_DAMG_CAUSE_CD', // 산림피해원인코드:
      'FORST_RECOVERY_STAT_CD', // 산림복구상태코드:
      'FORST_RECOVERY_STAT_DTL_CD', //산림복구상태상세코드:
      'FORST_PRC_GBN', // 산림처리구분:
      'CROPS_REG_KIND', // 작물등록유형:
      'FORST_RECY_STAT_DTL_CD', // 산림복구상태상세코드:
      'FORST_RECY_STAT_CD', //  산림복구상태코드:
      'DAT_ST_RLS_TP_CD', // 데이터셋공개유형코드:
      'OPRTR_SE_CD', // 작업자구분코드:
      'FORST_RCV_TYPE_CD', // 산림접수유형코드:
      'FORST_PRUS_PRMSN_CD', // 산림전용목적코드:
      'AI_MDL_TYPE_CD', // AIMODEL타입코드:
      'SAME_CD', //일치코드:
      'TILLAGE_CD', // 경작코드:
      'CROPS_AI_CLS_CD', // 작물AI분류코드:
      'CROPS_REG_CLS_CD', // 작물등록분류코드:
      'CROPS_SVC_CLS_CD', // 작물서비스분류코드:
    ],
  },
  REPORT: {
    YEAR: {
      YEARS: '/crops/register/form/years', //신고 프로젝트 연도 리스트
    },
    LIST: {
      REPORT_LIST: '/crops/register/form/list', // 신고서 리스트
      REPORT_LIST_TOTAL: '/crops/register/form/total/count', //신고서 리스트 총 수
      SAMPLE_DOWNLOAD: '/crops/register/form/sample/download', //신고서 양식 다운로드
      REPORT_LIST_DOWNLOAD: '/crops/map/reg/list/excel', //재배신고 리스트 엑셀 다운로드
      ClASS_EXCEL: 'crops/register/reg/class/emd/excel', //품목별 읍면동별 조사결과 집계표
      ADD_YEAR: '/crops/register/form/year/add', //신고 프로젝트 연도 리스트 추가
      CHECK_YEAR: '/crops/register/form/check/year', // 신고 프로젝트 연도 중복체크
      LAST_DATA: '/crops/register/form/last-data', //농지 소재지의 pnu로 전연 이력과 드론결과 가져오기
    },
    ADD: {
      EXCEL_UPLOAD: '/crops/register/form/excel/read', //신고서 엑셀파일 업로드
      EXCEL_ADD: '/crops/register/form/excel/add', //읽은 엑셀파일 DB에 반영
      CADASTRAL: '/crops/register/form/reg/cadastral', //농지 소재지의 pnu와 지적면적 조회
    },
    DETAIL: {
      USER_INFO: '/crops/register/user/info', //신고자 정보 상세보기
      DETAIL_LIST_TOTAL: '/crops/register/form/regs/count', //신고서 관리 상세보기 신고내용 리스트 총 수
      DETAIL_LIST: '/crops/register/form/regs', //신고서관리 상세보기 신고내용 리스트
      ADD_DATA: 'crops/register/form/regs/add', //신고서관리 상세보기 신고내용 추가
      DELETE_DATA: 'crops/register/form/regs/delete', //신고서관리 상세보기 신고내용 삭제 - 1 row
      DELETE_ALL_DATA: 'crops/register/form/regs/all/delete', // 신고서관리 전체 삭제
      UPDATE: '/crops/register/form/regs/update', // 신고서관리 상세보기 신고내용 수정
      PRINT_REPORT: 'crops/register/form/regs/excel/download', //엑셀 신고서 양식에 맞춰 리스트 다운로드(신고내역 출력)
      PRINT_ALL_REPORT: '/crops/register/form/print/data', //신고서 전체 출력(신고서 출력)
    },
  },
  USER: {
    LIST: {
      USER_LIST: '/crops/register/user/list', //신고자 리스트
      USER_LIST_TOTAL: '/crops/register/user/total/count', //신고자 리스트 총 수
      USER_LIST_INFO: '/crops/register/user/info', //신고자 정보 상세보기
      REPORTER_LIST_DOWNLOAD: '/crops/register/user/excel/download',
    },
    ADD: {
      USER_LIST: '/crops/register/user/add', //신고자 추가
      USER_DELETE: '/crops/register/user/delete', //신고자 삭제
    },
    DETAIL: {
      DETAIL_LIST: '/crops/register/form/regs', //신고서관리 상세보기 신고내용 리스트
      DETAIL_LIST_TOTAL: '/crops/register/form/regs/count', //신고서관리 상세보기 신고내용 리스트 총수
      UPDATE: '/crops/register/user/update', //상세보기 유저 업데이트
      ADD: '/crops/register/user/add',
    },
  },
  TILLAGE: {
    STATE: '/crops/map/tillage/state', // 농지이용실태 현황
    LIST: '/crops/map/tillage/list', // 농지이용실태 상세목록
    FEATURE: '/crops/map/tillage/list/feature', //농지이용실태 리스트 지도
    COUNT: '/crops/map/tillage/count',
    EXCEL: '/crops/map/tillage/list/excel',
    AI_LIST: '/crops/map/tillage/list/feature', // ai 탐지 작물 리스트 - (AI분석결과)
    DETAIL: '/crops/map/tillage/detail', //농지이용실태 상세보기
  },
  ADMIN: {
    WAIT_LIST: '/manage/user/wait/list',
    USER_LIST: '/manage/user/list',
    YEAR_LIST: '/common/year/list',
    PRODUCT_YEARS: '/manage/crops/prdctn/years',
    PRODUCT_LIST: '/manage/crops/prdctn/list',
    PRODUCT_ADD: '/manage/crops/prdctn/add',
    PRODUCT_UPDATE: '/manage/crops/prdctn/update',
    USER_ALLOW: '/manage/user/allow',
    USER_DELETE: '/manage/user/delete',
    USE_COUNT: '/manage/crops/use/count',
    EXCEL_DOWNLOAD: '/manage/crops/excel/download',
    EXCEL_UPLOAD: '/manage/crops/excel/read',
    EXCEL_ADD: '/manage/crops/use/excel/add',
    EXCEL_READ: '/manage/crops/use/excel/read',
    PAGE_LOG: '/user/page/log',
    GET_USER_DATA: '/check/id',
  },
};

export default ApiMapper;
